
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/material/styles";
import type { ComponentProps } from "react";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

function LoadingScreen({
  fullScreen,
  delayMs,
  ...props
}: {
  fullScreen?: boolean;
  /**
   * Wait this long before showing the spinner, so quick loads don't flash one.
   * The delay also keeps the space blank rather than showing a half-drawn page.
   */
  delayMs?: number;
} & ComponentProps<typeof Box>) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%", // Full width of the viewport
        backgroundColor: "background.default", // Use theme's default background color
        position: "absolute", // Position it on top of other elements
        left: 0,
        zIndex: 9999, // Make sure it's on top
        height: fullScreen ? "calc(100vh - 64px)" : "auto",
        ...(delayMs
          ? {
              opacity: 0,
              animation: `${fadeIn} 200ms ease-out ${delayMs}ms forwards`,
            }
          : {}),
      }}
      {...props}
    >
      <CircularProgress aria-label="Loading" />
    </Box>
  );
}

export default LoadingScreen;
